import SkyNetObjectProfile from '../components/SkyNetObjectProfile'
import {
    DataGridSupportedFeatures,
} from '../components/SkyNetMasterDataGrid/SkyNetMasterDataGrid.types'
import domainConfig from './ContractBasisDemo.config'

const featuresLists = [DataGridSupportedFeatures.ShowArchived]

const ContractBasisDemoPage = () => {
    return (
        <SkyNetObjectProfile
            config={domainConfig}
            featuresLists={featuresLists}
        />
    )
}

export default ContractBasisDemoPage
